// extracted by mini-css-extract-plugin
export default {"modal":"UubpjF","modalText":"J5zfxj"};